import { h, Component } from 'preact';
import style from './style';



class Loading extends Component {

    render() {
        const { isNotFound } = this.props;

        return (
            <div class={style.loadingContainer}>
                <div class={style.loading}>
                    {isNotFound ? <p>we could not find the page you were looking for...</p> : <div><div class={style.dualRingLoader}></div><div>Loading...</div></div>}
                </div>
            </div>);

    }

}

export default Loading;




// WEBPACK FOOTER //
// ./components/loader/Loading.js